export default {
    sections: {
        personal: 'Ajustes personales',
        security: 'Restablecer contraseña',
        apis: 'Gestionar token API',
        token: 'Token API disponible',
    },

    personal: {
        text1: `Edita tu información personal y configura la visibilidad de tu cuenta `,
        text2: `{name}`,
        text3: `.`,
    },

    security: {
        text: `Te enviaremos un correo electrónico con las instrucciones para restablecer tu contraseña.`,
        btn: 'Restablecer contraseña',
    },

    apis: {
        text: 'En esta vista puedes gestionar el token API para trabajar e integrarte con GBTEC Process Intelligence a través de su API REST.',
        generate: 'Generar token',
        cancel: 'Revocar token',
    },
    identificator: {
        success: 'Identificador copiado con éxito',
    },
    token: {
        tooltip: 'Copiar token al portapapeles',
        success: 'Token copiado con éxito',
        cancelled: 'Token revocado con éxito',
        modal: {
            title: 'Información del usuario',
            password: 'Contraseña',
            btn: 'Enviar',
        },
    },

    notifications: {
        personal: {
            text: 'Información personal actualizada correctamente.',
        },
        resetPassword: {
            text: 'Te enviaremos un mensaje de correo electrónico con las instrucciones para restablecer tu contraseña.',
        },
    },

    modals: {
        recovery: {
            title: 'Restablecer contraseña',
            text: '¿Seguro que quieres restablecer tu contraseña?',
        },
    },
}
